export default "__VITE_ASSET__qqEVjPuy__"